import querySelector from './querySelector.vue';
export default querySelector;



// WEBPACK FOOTER //
// ./src/components/querySelector/index.js